import React, { useState, useEffect } from 'react';
import { Button, VStack, useToast, Spinner, Center } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthLayout from '../components/layout/AuthLayout';
import FormInput from '../components/common/FormInput';
import useForm from '../hooks/useForm';
import { loginValidationSchema } from '../utils/validation';

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const {
    values,
    errors,
    handleChange,
    validate,
    reset
  } = useForm(
    { email: '', password: '' },
    loginValidationSchema
  );

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }

    setIsSubmitting(true);
    try {
      await login(values.email, values.password);
      reset();
      navigate('/');
    } catch (error) {
      console.error('Login error:', error);
      toast({
        title: "Login Error",
        description: error.message || "Failed to sign in",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (user) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return (
    <AuthLayout title="Welcome to SumaarohCRM V2">
      <form onSubmit={handleLogin}>
        <VStack spacing={4}>
          <FormInput
            label="Email"
            name="email"
            type="email"
            value={values.email}
            onChange={handleChange}
            error={errors.email}
            placeholder="Enter your email"
          />

          <FormInput
            label="Password"
            name="password"
            value={values.password}
            onChange={handleChange}
            error={errors.password}
            placeholder="Enter your password"
            isPassword={true}
            showPassword={showPassword}
            onTogglePassword={() => setShowPassword(!showPassword)}
          />

          <Button
            type="submit"
            colorScheme="blue"
            width="100%"
            isLoading={isSubmitting}
            loadingText="Signing in..."
            size="lg"
            mt={4}
          >
            Sign In
          </Button>
        </VStack>
      </form>
    </AuthLayout>
  );
};

export default LoginPage;
